document.addEventListener('click', function (e) {
  const prevButton = e.target.closest('.card-gallery-arrows__arrow-prev');
  const nextButton = e.target.closest('.card-gallery-arrows__arrow-next');

  if (!prevButton && !nextButton) return;

  const card = e.target.closest('.card-wrapper-new');
  if (!card) return;

  const mediaContainer = card.querySelector('.media');
  if (!mediaContainer) return;

  const scrollAmount = mediaContainer.clientWidth;

  mediaContainer.querySelectorAll('img').forEach((img) => {
    img.style.width = 'auto';
  });

  if (prevButton) {
    mediaContainer.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth',
    });
  }

  if (nextButton) {
    mediaContainer.scrollBy({
      left: scrollAmount,
      behavior: 'smooth',
    });
  }

  mediaContainer.querySelector('img')?.addEventListener('click', () => {
    const images = mediaContainer.querySelectorAll('img');

    if (!images || !images.length) return; // Exit early if no images

    images.forEach((img) => {
      if (img.complete && img.naturalWidth !== 0) {
        img.style.width = 'auto';
      } else {
        // If image not fully loaded, wait for it to load
        img.addEventListener('load', function onLoad() {
          img.style.width = 'auto';
          img.removeEventListener('load', onLoad); // Clean up
        });
      }
    });
  });
});

let observer;
const timers = new WeakMap();


function loadCardImages(card) {
  const elements = card.querySelectorAll('[data-src], [data-srcset]');
    elements.forEach(el => {
      if (el.dataset.src) {
        el.src = el.dataset.src;
        el.removeAttribute('data-src');
      }
      if (el.dataset.srcset) {
        el.srcset = el.dataset.srcset;
        el.removeAttribute('data-srcset');
      }
    })
}



function getAllCards() {
  const cards = document.querySelectorAll('.card-wrapper-new');
  cards.forEach(card => {
    card.addEventListener('mouseover', () => {
      loadCardImages(card);
    });
    card.addEventListener('touchstart', () => {
      loadCardImages(card);
    });
  });
}

window.addEventListener('load', getAllCards);

function resizeWrapper(media) {
  const images = media.querySelectorAll('img');
  if (images.length > 0) {
    const containerWidth = media.clientWidth;

    images.forEach(img => {
      if (img.style.width !== `${containerWidth}px`) {
        img.style.width = `${containerWidth}px`;
      }
    });

    //media.scrollLeft = 0; // align start
    media.dataset.resized = "true";
  }
}

function initObserver() {
  if (observer) return observer; // reuse same one

  observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      const media = entry.target;

      if (entry.isIntersecting && !media.dataset.resized) {
        if (!timers.has(media)) {
          const timerId = setTimeout(() => {
            resizeWrapper(media);
            obs.unobserve(media);
            timers.delete(media);
          }, 200);

          timers.set(media, timerId);
        }
      } else {
        if (timers.has(media)) {
          clearTimeout(timers.get(media));
          timers.delete(media);
        }
      }
    });
  }, { threshold: 0.3 });

  return observer;
}

function observeMediaElements() {
  const obs = initObserver();
  document.querySelectorAll('.media').forEach(media => {
    if (!media.dataset.observing) {
      obs.observe(media);
      media.dataset.observing = "true";
    }
  });
}

// ---- Bootstrapping ----
const productGridContainer = document.querySelector('.product-grid-container');
if (productGridContainer) {
  window.addEventListener('load', observeMediaElements);
}

// ---- Hook into "load more" ----
document.addEventListener('load-more-done', () => {
  if (productGridContainer) {
    observeMediaElements(); // observe new items too
    getAllCards();
  }
  buttonOpacity();
});


function buttonOpacity() {
  const allCards = document.querySelectorAll('.card-wrapper-new');

  allCards.forEach(card => {
    const mediaContainer = card.querySelector('.media');
    const prevButton = card.querySelector('.card-gallery-arrows__arrow-prev');
    const nextButton = card.querySelector('.card-gallery-arrows__arrow-next');

    if (!mediaContainer) return;

    const updateButtonState = () => {
      const scrollLeft = mediaContainer.scrollLeft;
      const scrollWidth = mediaContainer.scrollWidth;
      const containerWidth = mediaContainer.clientWidth;

      const atStart = scrollLeft <= 0;
      const atEnd = scrollLeft + containerWidth >= scrollWidth-1; // small buffer


      prevButton.classList.toggle('card-gallery-arrows__arrow--disabled', atStart);

      if (atStart) {
        if (atEnd) {
          nextButton.classList.remove('card-gallery-arrows__arrow--disabled');
        } else {
          nextButton.classList.remove('card-gallery-arrows__arrow--disabled');
        }
      } else {
        if (atEnd) {
          nextButton.classList.add('card-gallery-arrows__arrow--disabled');
        } else {
          nextButton.classList.remove('card-gallery-arrows__arrow--disabled');
        }
      }
    };

    // Set initial state
    updateButtonState();

    // Update on scroll
    mediaContainer.addEventListener('scroll', updateButtonState);
  });
}


